import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'styled-components'
import { colours } from '@qflow/theme'

import { Flex, SubHeading } from 'portal/lib/primitives'
import {
  AttachmentUploadButton,
  AttachmentUploadError
} from './AttachmentsPanel'

export function AttachmentsHeader({ record }) {
  return (
    <Flex.Row amount={0} verticalCentre css={containerCss}>
      <SubHeading
        isChild
        style={{ fontSize: '1.125rem', color: colours.CORE_NAVY }}
      >
        Attachments
      </SubHeading>

      {record.canEdit && <AttachmentUploadButton record={record} />}
      <AttachmentUploadError />
    </Flex.Row>
  )
}

AttachmentsHeader.propTypes = {
  record: PropTypes.object.isRequired
}

const containerCss = css`
  justify-content: space-between;
  margin-bottom: 0.5rem;
`
